import { Component } from '@verndale/core';
import { gsap, Expo } from 'gsap';
import { debounce } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.breakpoint = matchMedia('(max-width: 1279px)');

    this.showMoreLabel = this.el.dataset.showMoreLabel;
    this.showLessLabel = this.el.dataset.showLessLabel;

    this.dom = {
      container: document.querySelector('.masthead__frame__inner'),
      text: document.querySelector('.masthead__frame-description')
    };

    this.dom.button = document.createElement('button');
    this.dom.button.classList = 'btn btn--secondary btn--outline';
    this.dom.button.innerHTML = this.showMoreLabel;

    this.checkCollapseText();
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.checkCollapseText.bind(this), 500)
    );
    this.dom.button.addEventListener(
      'click',
      this.handleShowMoreLess.bind(this)
    );
  }

  checkCollapseText() {
    if (this.breakpoint.matches) {
      if (this.dom.text.offsetHeight < this.dom.text.scrollHeight) {
        this.dom.container.append(this.dom.button);
      } else {
        this.dom.button.remove();
      }
    } else {
      this.dom.text.style.height = null;
      this.dom.button.remove();
    }
  }

  handleShowMoreLess(e) {
    e.stopPropagation();

    if (
      this.dom.text.classList.contains('masthead__frame-description--expanded')
    ) {
      this.collapse();
      this.dom.button.innerHTML = this.showMoreLabel;
    } else {
      this.expand();
      this.dom.button.innerHTML = this.showLessLabel;
    }
  }

  expand() {
    this.textHeight = this.dom.text.offsetHeight;
    this.dom.text.classList.add('masthead__frame-description--expanded');
    gsap.set(this.dom.text, { height: 'auto' });
    gsap.from(this.dom.text, {
      height: this.textHeight,
      ease: Expo.easeOut,
      duration: 0.4,
      onComplete: () => {
        this.dom.text.style.height = null;
      }
    });
  }

  collapse() {
    gsap.set(this.dom.text, { height: this.dom.text.offsetHeight });
    gsap.to(this.dom.text, {
      height: this.textHeight,
      ease: Expo.easeOut,
      duration: 0.4,
      onComplete: () => {
        this.dom.text.classList.remove('masthead__frame-description--expanded');
        this.dom.text.style.height = null;
      }
    });
  }
}

export default Module;
